import { Inject } from '@odinjs/odin';
import { ButtonAPI, InputAPI, ModalAPI, QRCodeAPI, WizardAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnBeforeClose, OnClick, OnMount, OnValidate } from '@philips-internal/oswald-ui-core/lib/client';
import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import BaseController from '../BaseController';
import { FragmentNames, SecurityActivationModalAliases } from '../../codegen';
import { ModalContext, TwoFactorVO } from '../../interfaces/security-authentication';
import { showToastNotificationError } from '../../utils/toast-notification-utils';
import { mfaExpressions } from '../../constants/security-authentication';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { SubmitEvent, ValidateEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { ContextType } from '@philips-internal/oswald-ui-core';
import { SubmittableFragmentContext } from '@philips-internal/oswald-ui-core/lib/component';

@Controller({ fragment: FragmentNames.SECURITY_ACTIVATION_MODAL })
export default class SecurityActivationModalController extends BaseController {

  @Inject(SecurityActivationModalAliases.INPUT_MFA_COPY_SECRET)
    inputCopySecreteAPI!: InputAPI;

  @Inject(SecurityActivationModalAliases.QRCODE_SCAN_IMG)
    qrcodeAPI!: QRCodeAPI;

  @Inject(SecurityActivationModalAliases.MODAL_SECURITY_ACTIVATION)
    modalApi!: ModalAPI;

  @Inject(SecurityActivationModalAliases.BUTTON_RESEND_CODE)
    buttonResendCodeApi!: ButtonAPI;

  @Inject(SecurityActivationModalAliases.WIZARD_AUTHENTICATION)
    wizzardMfaApi!: WizardAPI;

  @Inject(ContextType.SUBMITTABLE_FRAGMENT)
    submittableFragmentContext!: SubmittableFragmentContext;

  @OnMount({ target: SecurityActivationModalAliases.LAYOUT_MFA_SECRET_INFO })
  onMountSecretInfo(): void {
    const mfaContext = this.context.get('mfaContext') as ModalContext;
    this.inputCopySecreteAPI.setValue(mfaContext.twoFactor.secret);
  }

  @OnMount({ target: SecurityActivationModalAliases.QRCODE_SCAN_IMG })
  onMountQrcode(): void {
    const mfaContext = this.context.get('mfaContext') as ModalContext;
    this.qrcodeAPI.setValue(mfaContext.twoFactor.link);
  }

  @OnValidate(SecurityActivationModalAliases.FORM_INPUT_MFA_COPY_SECRET)
  handleFormSecretValidate(validateEvent: ValidateEvent): void {
    this.wizzardMfaApi.setStepDone(this.wizzardMfaApi.getCurrentStepIdentifier(), validateEvent.valid);
  }

  @OnValidate(SecurityActivationModalAliases.FORM_QRCODE_SCAN_IMG)
  handleFormQrCodeValidate(validateEvent: ValidateEvent): void {
    this.wizzardMfaApi.setStepDone(this.wizzardMfaApi.getCurrentStepIdentifier(), validateEvent.valid);
  }

  @OnClick({ target: SecurityActivationModalAliases.BUTTON_RESEND_CODE })
  onClickButtonResendCode(): void {
    HttpService.put(APPLICATION_ENDPOINTS.PUT_REQUEST_AUTHENTICATION, {})
      .then(response => {
        const twoFactor = response.body as TwoFactorVO;
        this.inputCopySecreteAPI.setValue(twoFactor.secret);
        this.qrcodeAPI.setValue(twoFactor.link);
      })
      .catch(() => {
        showToastNotificationError(MessageService.translate(mfaExpressions.SYSTEM_INTERNAL_ERROR));
      });
  }

  @OnBeforeClose({ target: SecurityActivationModalAliases.MODAL_SECURITY_ACTIVATION })
  onSecurityModalClose(): void {
    this.submittableFragmentContext.cancel(new SubmitEvent());
  }

}
